import React from 'react';
import { Link } from 'react-router-dom';

// Placeholder images
const heroImage = 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?q=80&w=1968&auto=format&fit=crop';
const yogaImage = 'https://images.unsplash.com/photo-1575052814086-f385e2e2ad1b?q=80&w=1964&auto=format&fit=crop';
const hiitImage = 'https://images.unsplash.com/photo-1540497077202-7c8a3999166f?q=80&w=1770&auto=format&fit=crop';
const spinImage = 'https://images.unsplash.com/photo-1571388208497-71bedc66e932?q=80&w=1772&auto=format&fit=crop';
// const gymImage = 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?q=80&w=1770&auto=format&fit=crop';
const appImage = 'https://images.unsplash.com/photo-1605296867304-46d5465a13f1?q=80&w=1770&auto=format&fit=crop';

const Home = () => {
  return (
    <>
      {/* Hero Section */}
      <section 
        className="relative bg-cover bg-center py-20 md:py-32" 
        style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.7)), url(${heroImage})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-transparent"></div>
        <div className="container-custom relative z-10 text-white">
          <div className="max-w-2xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
              The Ultimate <span className="text-gradient">Fitness Access</span> Platform
            </h1>
            <p className="text-xl mb-8 text-gray-200">
              Book a wide range of fitness activities at multiple locations on one platform. Experience workout variety and flexibility across Egypt with Sportify.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/how-it-works" className="btn btn-primary">
                Discover the App
              </Link>
              <Link to="/contact" className="btn btn-outline text-white border-white hover:bg-white hover:text-primary">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* App Features */}
      <section className="py-20 bg-gray-50">
        <div className="container-custom">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 bg-secondary bg-opacity-30 text-primary rounded-full text-sm font-medium mb-4">App Features</span>
            <h2 className="text-3xl font-bold mb-4">Discover the Sportify App</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Our mobile app revolutionizes how you access fitness activities across Egypt.
              Book classes, sessions, and experiences at multiple locations all on one platform, offering unprecedented
              flexibility for your fitness journey.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Feature 1 */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden transform hover:-translate-y-2 transition-all duration-300 hover:shadow-lg">
              <div className="relative overflow-hidden">
                <img src={yogaImage} alt="Workout Variety" className="w-full h-48 object-cover" />
                <div className="absolute inset-0 bg-primary/10 flex items-center justify-center">
                  <div className="bg-white/90 backdrop-blur-sm rounded-full p-4">
                    <svg className="w-10 h-10 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Diverse Workout Options</h3>
                <p className="text-gray-600">Access a wide range of fitness activities from yoga to HIIT across multiple venues, catered to every fitness level and interest.</p>
              </div>
            </div>

            {/* Feature 2 */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden transform hover:-translate-y-2 transition-all duration-300 hover:shadow-lg">
              <div className="relative overflow-hidden">
                <img src={hiitImage} alt="Smart Booking" className="w-full h-48 object-cover" />
                <div className="absolute inset-0 bg-primary/10 flex items-center justify-center">
                  <div className="bg-white/90 backdrop-blur-sm rounded-full p-4">
                    <svg className="w-10 h-10 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Smart Booking System</h3>
                <p className="text-gray-600">Reserve classes instantly with our intuitive interface. Manage your fitness schedule with ease using our calendar integration.</p>
              </div>
            </div>

            {/* Feature 3 */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden transform hover:-translate-y-2 transition-all duration-300 hover:shadow-lg">
              <div className="relative overflow-hidden">
                <img src={spinImage} alt="Location Services" className="w-full h-48 object-cover" />
                <div className="absolute inset-0 bg-primary/10 flex items-center justify-center">
                  <div className="bg-white/90 backdrop-blur-sm rounded-full p-4">
                    <svg className="w-10 h-10 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">All-Access Platform</h3>
                <p className="text-gray-600">Enjoy access to multiple fitness facilities across Egypt through one platform. Work out wherever and whenever it suits you.</p>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <Link to="/how-it-works" className="btn btn-outline">
              Learn More
            </Link>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-white">
        <div className="container-custom">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 bg-secondary bg-opacity-30 text-primary rounded-full text-sm font-medium mb-4">Key Features</span>
            <h2 className="text-3xl font-bold mb-4">Why Choose Sportify?</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Our platform makes fitness accessible, flexible, and enjoyable. Here's how Sportify
              helps you take control of your fitness journey across Egypt.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Benefit 1 */}
            <div className="p-8 bg-white rounded-xl shadow hover:shadow-xl transition-shadow border border-gray-100 group">
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-secondary bg-opacity-20 mb-6 group-hover:bg-primary group-hover:text-white transition-colors">
                <svg className="w-7 h-7 text-primary group-hover:text-white transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3">Flexible Booking</h3>
              <p className="text-gray-600">Book classes at your convenience with options that fit any schedule. No long-term commitments required.</p>
            </div>

            {/* Benefit 2 */}
            <div className="p-8 bg-white rounded-xl shadow hover:shadow-xl transition-shadow border border-gray-100 group">
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-secondary bg-opacity-20 mb-6 group-hover:bg-primary group-hover:text-white transition-colors">
                <svg className="w-7 h-7 text-primary group-hover:text-white transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3">Multiple Venues</h3>
              <p className="text-gray-600">Access a curated selection of quality fitness facilities across Egypt, all through one convenient platform.</p>
            </div>

            {/* Benefit 3 */}
            <div className="p-8 bg-white rounded-xl shadow hover:shadow-xl transition-shadow border border-gray-100 group">
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-secondary bg-opacity-20 mb-6 group-hover:bg-primary group-hover:text-white transition-colors">
                <svg className="w-7 h-7 text-primary group-hover:text-white transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3">Real-Time Notifications</h3>
              <p className="text-gray-600">Get instant booking confirmations, class reminders, and updates about new classes at your favorite venues.</p>
            </div>

            {/* Benefit 4 */}
            <div className="p-8 bg-white rounded-xl shadow hover:shadow-xl transition-shadow border border-gray-100 group">
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-secondary bg-opacity-20 mb-6 group-hover:bg-primary group-hover:text-white transition-colors">
                <svg className="w-7 h-7 text-primary group-hover:text-white transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3">Smart Location Services</h3>
              <p className="text-gray-600">Our advanced geolocation features show nearby fitness venues and enable seamless check-ins for your convenience.</p>
            </div>
          </div>
        </div>
      </section>

      {/* App Promotion */}
      <section className="py-20 bg-gray-50">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="inline-block px-3 py-1 bg-secondary bg-opacity-30 text-primary rounded-full text-sm font-medium mb-4">Mobile Experience</span>
              <h2 className="text-3xl font-bold mb-6">Get the Sportify Mobile App</h2>
              <p className="text-gray-600 mb-8 text-lg">
                Access multiple fitness venues with one convenient app. Book classes, explore new workouts,
                and enjoy unprecedented flexibility with Sportify.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <div className="h-6 w-6 rounded-full bg-green-100 flex items-center justify-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-green-600" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                  <p className="ml-3 text-gray-700">Book classes at multiple venues with a few taps</p>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <div className="h-6 w-6 rounded-full bg-green-100 flex items-center justify-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-green-600" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                  <p className="ml-3 text-gray-700">Discover new workout venues across Egypt</p>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <div className="h-6 w-6 rounded-full bg-green-100 flex items-center justify-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-green-600" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                  <p className="ml-3 text-gray-700">Access multiple fitness facilities from one platform</p>
                </div>
              </div>
              
            </div>
            <div className="order-first lg:order-last relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary/20 to-secondary/20 rounded-3xl blur-lg opacity-60"></div>
              <img 
                src={appImage} 
                alt="Sportify Mobile App" 
                className="relative w-full max-w-md mx-auto rounded-2xl shadow-2xl border-8 border-white"
              />
            </div>
          </div>
        </div>
      </section>


      {/* Call to Action */}
      <section className="py-20 bg-primary text-white relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-primary via-primary to-accent1 opacity-90"></div>
          <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-dark/20 to-transparent"></div>
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10">
            <div className="absolute -right-10 -top-10 h-64 w-64 rounded-full bg-white"></div>
            <div className="absolute -left-20 top-1/3 h-96 w-96 rounded-full bg-white"></div>
          </div>
        </div>
        <div className="container-custom text-center relative z-10">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">Ready to Access Multiple Fitness Venues?</h2>
            <p className="text-xl mb-10 max-w-2xl mx-auto">
              Download the Sportify app today and experience a new level of convenience in booking fitness classes.
              Access multiple venues across Egypt, all at your fingertips.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/how-it-works" 
                className="btn text-primary bg-white hover:bg-gray-100 border-white shadow-lg px-10 py-4 text-lg font-semibold transition-all duration-300 hover:shadow-xl"
              >
                How It Works
              </Link>
              <Link 
                to="/contact" 
                className="btn border-white text-white hover:bg-white/10 px-10 py-4 text-lg font-semibold"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;